import TenantRoleList from "./components/List"
import TenantRoleForm from "./components/Form"

let module = "tenantroles"

export default [
  {
    path: "tenantroles",
    component: TenantRoleList,
    meta: { module: module, permissions: ["tenantrole-access"] }
  },
  {
    path: "tenantroles/create",
    component: TenantRoleForm,
    props: true,
    meta: { module: module, permissions: ["tenantrole-create"] }
  },
  {
    path: "tenantroles/edit/:id",
    component: TenantRoleForm,
    props: true,
    meta: { module: module, permissions: ["tenantrole-edit"] }
  }
]
